import { Merchant } from "@/dto/merchant";

/**
 * Determines whether a merchant has an empty or unconfigured weekly schedule.
 *
 * This checks the base business hours configuration. It returns true if the
 * `businessHours` object is missing entirely, or if every day of the week
 * has zero scheduled intervals (length of 0).
 *
 * @param {Merchant} [merchant] - The merchant object containing the business hours configuration.
 * @returns {boolean} Returns `true` if no business hours are configured, otherwise `false`.
 */
export const hasEmptyBusinessHours = (merchant?: Merchant): boolean => {
  const hours = merchant?.businessHours?.hours;

  if (!hours) return true;

  return Object.values(hours).every((day: any) => day.length === 0);
};
